import {SBL_DASHBOARD_ACTIONS, DEFAULT_PERCENTILE} from "../../../util/Constants";

export const SBLDashboardReducer = (state, action) => {
    switch (action.type) {
        case SBL_DASHBOARD_ACTIONS.LOAD_VIEW:
            return {...state, loading: true, error: null};
        case SBL_DASHBOARD_ACTIONS.RECEIVE_CONFIG:
            return {...state, percentileThreshold: action.data || DEFAULT_PERCENTILE};
        case SBL_DASHBOARD_ACTIONS.RECEIVE_DATA:
            return {...state, resourceDynamicAttributes: action.data, loading: false, error: null};
        case SBL_DASHBOARD_ACTIONS.RECEIVE_ERROR:
            return {...state, resourceDynamicAttributes: [], loading: false, error: action.data};
        case SBL_DASHBOARD_ACTIONS.SORT_DATA:
            return {...state, sortPref: action.data};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/reducer/SBLDashboardReducer.js